import AppManager from "../managers/AppManager";
import ApiConstants from "../constants/ApiConstants";
import UserManager from "./UserManager";
import { showLoader, removeLoader, showAlert } from "deskera-ui-library";
import TimeoutManager from "./TimeoutManager";
import i18next from "i18next";

export default class ApiManager {
  static commonError = "Server error occured. Please try again later.";

  ////////////////////////////////////////////
  ////////////////////////////////////////////

  static parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  ////////////////////////////////////////////
  ////////////////////////////////////////////

  static getApiRequestOptions(method, body = null) {
    var requestOptions = {
      method: method,
      credentials: "include",
      withCredentials: true,
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        accept: "*/*",
        // "x-access-token": ApiConstants.ACCESS_TOKEN,
      },
    };
    if (method === "POST" || method === "PUT") {
      body = JSON.stringify(body);
      requestOptions = { ...requestOptions, body };
    }
    return requestOptions;
  }

  ////////////////////////////////////////////
  ////////////////////////////////////////////

  static async checkIfUserLoggedIn(onSuccess, onFail, isRetry) {
    AppManager.isStatusChecked = false
    await fetch(
      ApiConstants.URL.BASE + ApiConstants.URL.IAM.STATUS,
      ApiManager.getApiRequestOptions("GET")
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then((data) => {
        if (data && data.accessToken) {
          ApiManager.tokenReceived(data.accessToken, data.emailVerified);
          
          onSuccess();
          return true
        } else if(data.code == 502 || data.code == 504) {
          isRetry = isRetry ? isRetry : 0;
        if(isRetry < ApiConstants.STATUS_RETRY_COUNT) {
          isRetry = (isRetry + 1)
          setTimeout(()=>{
            AppManager.didSessionExpired = false;
            AppManager.isStatusChecked = true;
            return ApiManager.checkIfUserLoggedIn(onSuccess,null, isRetry)
          },2000)
        } else if( isRetry == ApiConstants.STATUS_RETRY_COUNT) {
          // get Refresh Token
          isRetry = (isRetry + 1)
          return ApiManager.getRefreshToken(onSuccess,isRetry)

        } else {
          AppManager.gotoLoginPage(false);
          return false
        }
        }
        else {
          // onFail();
          AppManager.gotoLoginPage(false);
          return false
        }
      })
      .catch((error) => {
        // onFail();
        isRetry = isRetry ? isRetry : 0
        if((error.status == 502 || error.status == 504) && ( isRetry < ApiConstants.STATUS_RETRY_COUNT)) {
          isRetry = (isRetry + 1)
          setTimeout(()=>{
            AppManager.didSessionExpired = false;
            AppManager.isStatusChecked = true;
            return ApiManager.checkIfUserLoggedIn(onSuccess,null, isRetry)
          },2000)
        } else if( isRetry == ApiConstants.STATUS_RETRY_COUNT) {
          // get Refresh Token
          isRetry = (isRetry + 1)
          return ApiManager.getRefreshToken(onSuccess,isRetry)

        } else {
          AppManager.gotoLoginPage(false);
          return false
        }
      });
  }

  static async getRefreshToken(onSuccess,isRetry) {
      // Note: comment code for Future use
      // let decodedToken = ApiManager.parseJwt(token);

      let body = {
        refreshToken:"eyJjdHkiOiJKV1QiLCJlbmMiOiJ",
        tenantId: -1,//decodedToken.tenantId,
        userName: 'lywepumu@deskera.com' //decodedToken.email
      }
      await fetch(
        ApiConstants.URL.BASE + ApiConstants.URL.IAM.REFRESH_TOKEN,
        ApiManager.getApiRequestOptions("POST",body)
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response);
        })
        .then((data) => {
          if(data) {
            console.log(data);
            AppManager.didSessionExpired = true;
            AppManager.isStatusChecked = true;
            // AppManager.gotoLoginPage()
          // if (data && data.accessToken) {
            // ApiManager.tokenReceived(data.accessToken, data.emailVerified);
            // onSuccess();
            // return ApiManager.checkIfUserLoggedIn(onSuccess,null, isRetry)
            ApiManager.tokenReceived(data.accessToken, data.emailVerified);
            onSuccess();

            
          } else {
            // onFail();
            AppManager.gotoLoginPage(false);
            return false
          }
        })
        .catch((error) => {
          AppManager.gotoLoginPage(false);
          return false
        })
      
  }
  static tokenReceived(accessToken, emailVerified) {
    let token = ApiManager.parseJwt(accessToken);
    ApiConstants.ACCESS_TOKEN = accessToken;

    // Set token expiry time
    TimeoutManager.setTokenExpiryTime(token.exp);

    let user = {
      imID: token.iamUserId,
      id: token.userId,
      tenantID: token.tenantId,
      name: token.name,
      email: token.email,
      phone: token.phone_number,
      website: token.website,
      tenantName: token.website,
      country: token.taxResidency,
      currency: token.currency,
      isOrgSet: token.isOrgSet,
      emailVerified: emailVerified,
    };
    UserManager.setUserDetails(user);
    AppManager.userLoggedIn();
  }

  ////////////////////////////////////////////
  ////////////////////////////////////////////

  static checkIfSessionExpired(error, needToShowAlert = true) {
    if (error.toString() === "TypeError: Failed to fetch") {
      alert("Your session is expired. Please login again.");
      AppManager.gotoLoginPage();
    } else {
      if (needToShowAlert) {
        alert(error);
      }
    }
  }

  ////////////////////////////////////////////
  ////////////////////////////////////////////

  static sendEmail(subject, recipients, body, callback, needAlert = true) {
    showLoader();

    var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "multipart/form-data");
    // myHeaders.append("Accept", "application/json");

    var formdata = new FormData();
    formdata.append("body", body);
    formdata.append("recipientEmail", recipients);
    formdata.append("recipientName", "Deskera");
    formdata.append("subject", subject);
    formdata.append("senderName", "Deskera");
    // formdata.append("replyTo", "piyush.kandrikar@deskera.com");
    // formdata.append("sendCopy", "piyush.kandrikar@deskera.com");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      "https://api-dev.deskera.xyz/v1/anonymous/document-designer/email",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        removeLoader();
        if (needAlert) {
          showAlert(
            "Email sent!",
            "Email has been sent successfully. Please check your inbox."
          );
        }
        callback();
      })
      .catch((error) => {
        console.log("error", error);
        removeLoader();
        callback();
      });
  }

  static getUploadFileURL(imageData, success, failed) {
    showLoader("Uploading....");
    let url = ApiConstants.URL.BASE + "v1/attachment/file-upload/public";
    let inputData = new FormData();
    inputData.append("file", imageData);
    inputData.append("file-entity", "REPORT_THUMBNAIL");

    let requestOptions = {
      method: "POST",
      credentials: "include",
      withCredentials: true,
      mode: "cors",
      body: inputData,
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData && responseData.publicUrl) {
          success(responseData.publicUrl);
          removeLoader();
        } else if(responseData?.status === 500 && responseData?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
          showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
          removeLoader();
          failed({ errorMessage: "Please try again." });
        } else {
          removeLoader();
          failed({ errorMessage: "Please try again." });
        }
      })
      .catch((error) => {
        removeLoader();
        failed({ errorMessage: "Please try again." });
      });
  }

  static getPublicPageJSONData(id, onSuccess, OnError) {
    showLoader("Loading....");
    let url =
      ApiConstants.URL.BASE + ApiConstants.URL.PUBLIC_PAGE.GET_JSON_DATA(id);

    let requestOptions = {
      method: "GET",
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData) {
          onSuccess(responseData);
        } else {
          OnError({ errorMessage: "Please try again." });
        }
      });
  }
}
